module.exports = __webpack_public_path__ + "static/media/waves-bg.bd2b1390.png";